"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const QUERY = '(prefers-reduced-motion: no-preference)';
exports.default = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const mediaQueryList = window.matchMedia(QUERY);
        setPrefersReducedMotion(!window.matchMedia(QUERY).matches);
        /**
         * @param {MediaQueryListEvent} event
         */
        const listener = (event) => {
            setPrefersReducedMotion(!event.matches);
        };
        if (mediaQueryList.addEventListener) {
            mediaQueryList.addEventListener('change', listener);
        }
        else {
            // polyfil for Safari and IE
            mediaQueryList.addListener(listener);
        }
        return () => mediaQueryList.removeEventListener
            ? mediaQueryList.removeEventListener('change', listener)
            : mediaQueryList.removeListener(listener);
    }, []);
    return prefersReducedMotion;
};
//# sourceMappingURL=index.js.map